import { render } from "./EntraRecommendations.vue?vue&type=template&id=1c81b001&scoped=true"
import script from "./EntraRecommendations.vue?vue&type=script&lang=js"
export * from "./EntraRecommendations.vue?vue&type=script&lang=js"

import "./EntraRecommendations.vue?vue&type=style&index=0&id=1c81b001&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c81b001"]])

export default __exports__